<section class="section">
	<div class="inner">
		<p class="section-label">Your Skin Profile</p>
		<h2 class="section-title">Analysis Results</h2>
		<p class="sample-note">Example only. Your own results come from your scan.</p>
		<div class="analysis-card">
			<div class="concern-row">
				<span class="concern-name">Oily Skin</span>
				<div class="concern-score-bar"><div class="concern-score-fill" style="width: 85%"></div></div>
			</div>
			<div class="concern-row">
				<span class="concern-name">Hyperpigmentation</span>
				<div class="concern-score-bar"><div class="concern-score-fill" style="width: 72%"></div></div>
			</div>
			<div class="concern-row">
				<span class="concern-name">Large Pores</span>
				<div class="concern-score-bar"><div class="concern-score-fill" style="width: 64%"></div></div>
			</div>
			<div class="concern-row">
				<span class="concern-name">Wrinkles</span>
				<div class="concern-score-bar"><div class="concern-score-fill" style="width: 45%"></div></div>
			</div>
			<div class="strengths">
				<span class="strength-badge">&#10024; Smooth Texture</span>
				<span class="strength-badge">&#10024; Even Hydration</span>
				<span class="strength-badge">&#10024; Clear Complexion</span>
			</div>
		</div>
	</div>
</section>

<style>
	.section {
		padding: var(--section-gap) var(--page-pad-x);
		background: var(--bg);
	}

	.inner {
		max-width: var(--content-max);
		margin: 0 auto;
	}

	/* The shared .section-title parks --section-gap below itself, which
	   double-counts against this section's own --section-gap padding. Type,
	   colour and alignment stay from the primitive; only the trailing space
	   is re-parked, identically in all four landing sections. */
	.section-title {
		margin-bottom: var(--space-12);
	}

	/* Required labelling for fabricated data. Body size, muted, sentence case:
	   it sits directly above the card it qualifies and must stay readable. */
	.sample-note {
		max-width: var(--prose-max);
		margin: 0 auto var(--space-6);
		text-align: center;
		font-size: var(--text-sm);
		line-height: var(--leading-normal);
		color: var(--text-muted);
	}

	.analysis-card {
		max-width: var(--prose-max);
		margin: 0 auto;
		background: var(--surface);
		border: 1px solid var(--border);
		padding: var(--card-pad);
	}

	.concern-row {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: var(--space-6);
		padding: var(--space-4) 0;
	}

	/* Rules between rows, never a trailing one. The old :last-of-type never
	   matched, because .strengths is the last div in the card. */
	.concern-row + .concern-row {
		border-top: 1px solid var(--border);
	}

	.concern-name {
		font-size: var(--text-sm);
		font-weight: var(--weight-light);
		color: var(--cream);
	}

	.concern-score-bar {
		flex: 0 1 160px;
		/* 2px: no space token sits between --space-px and --space-1, and a
		   1px rose line is not legible on this ground. */
		height: 2px;
		background: var(--border);
		overflow: hidden;
	}

	.concern-score-fill {
		height: 100%;
		background: var(--rose);
	}

	.strengths {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		gap: var(--space-2);
		margin-top: var(--space-8);
		padding-top: var(--space-8);
		border-top: 1px solid var(--border);
	}

	.strength-badge {
		display: inline-flex;
		align-items: center;
		gap: var(--space-2);
		padding: var(--space-2) var(--space-3);
		border: 1px solid var(--rose-line);
		border-radius: var(--radius-0);
		color: var(--rose);
		font-size: var(--text-2xs);
		letter-spacing: var(--track-label);
		text-transform: uppercase;
	}
</style>
